import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import "./globalStyles.scss";
import store from "./redux/store/store";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { setHeight, setWidth } from "./redux/reducers/appReducer";
import { Provider } from "react-redux";
import Router from "./Router";
import "./i18n/i18n";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

if (window.innerWidth < 1440) {
  store.dispatch(setWidth(window.innerWidth));
  store.dispatch(setHeight(window.innerHeight));
  document.getElementsByTagName("body")[0]?.classList.add("dui-tablet-view");
}

root.render(
  <Provider store={store}>
    <Router />
  </Provider>
);
